import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useRegion } from "@/hooks/useRegion";
import type { Region } from "@/lib/region";

const VALID: Region[] = ["IN", "EU", "UK", "US", "AU", "ROW"];

interface Props {
  children: React.ReactNode;
  /** Where to redirect to (canonical page) after applying region. */
  to: string;
}

/**
 * Reads :region URL param, applies it via useRegion(), then redirects to canonical path.
 * Used for /terms/eu, /returns/us style aliases.
 */
export default function RegionAlias({ children, to }: Props) {
  const { region: regionParam } = useParams<{ region: string }>();
  const { setRegion } = useRegion();
  const navigate = useNavigate();

  useEffect(() => {
    const r = (regionParam ?? "").toUpperCase() as Region;
    if (VALID.includes(r)) setRegion(r);
    navigate(to, { replace: true });
  }, [regionParam, setRegion, navigate, to]);

  return <>{children}</>;
}
